/**
 * REK (Basisrekenen) Module Seeds - DDD Canonical Location
 *
 * Created 17 maart 2026 (REK module Fase 0).
 * Migrated families:
 * - REK-SCHATTEN ← GET-SCHATSTRATEGIE
 * - REK-VOLGORDE ← GET-VOLGORDE-BEWERKING
 *
 * Fase 1 seeds (17 maart 2026):
 * - REK-TAFELS-BASIS (6 vragen: fill_in, MC)
 * - REK-CIJF-PLUS (5 vragen: fill_in, MC)
 * - REK-CIJF-MIN (5 vragen: fill_in, MC)
 * - REK-HANDIG-PLUS-MIN (5 vragen: MC, fill_in — bevat gemigreerde GET-HOOFDREKENEN Q001/Q002/Q004)
 *
 * Fase 2 seeds (17 maart 2026):
 * - REK-TAFELS-TOEPASSEN (5 vragen: MC — tafels in context)
 * - REK-TAFELS-UITBREIDEN (5 vragen: fill_in, MC — tafels >10, kruistafels, deeltafels)
 * - REK-HANDIG-KEER (5 vragen: MC, fill_in — bevat gemigreerde GET-HOOFDREKENEN Q003/Q005)
 * - REK-CONTEXT-PLUS-MIN (5 vragen: MC — redactiesommen optellen & aftrekken)
 * - REK-GEMENGD-BASIS (5 vragen: MC, fill_in — mix bewerkingen)
 *
 * Fase 3 seeds (17 maart 2026):
 * - REK-CIJF-KEER (5 vragen: fill_in, MC — cijferend vermenigvuldigen)
 * - REK-CIJF-DEEL (5 vragen: fill_in, MC — staartdeling)
 * - REK-HANDIG-DEEL (5 vragen: MC, fill_in — handig delen via factoren/halveren)
 * - REK-CONTEXT-KEER-DEEL (5 vragen: MC — redactiesommen vermenigvuldigen & delen)
 *
 * Fase 4 seeds (17 maart 2026):
 * - REK-CONTEXT-MEERSTAPS (5 vragen: MC — meerstaps-opgaven, Bloom 4)
 * - REK-GEMENGD-TOETS (5 vragen: MC, fill_in — toets-mix alle bewerkingen)
 */

import REK_SCHATTEN from './REK-SCHATTEN.json';
import REK_VOLGORDE from './REK-VOLGORDE.json';
import REK_TAFELS_BASIS from './REK-TAFELS-BASIS.json';
import REK_CIJF_PLUS from './REK-CIJF-PLUS.json';
import REK_CIJF_MIN from './REK-CIJF-MIN.json';
import REK_HANDIG_PLUS_MIN from './REK-HANDIG-PLUS-MIN.json';
import REK_TAFELS_TOEPASSEN from './REK-TAFELS-TOEPASSEN.json';
import REK_TAFELS_UITBREIDEN from './REK-TAFELS-UITBREIDEN.json';
import REK_HANDIG_KEER from './REK-HANDIG-KEER.json';
import REK_CONTEXT_PLUS_MIN from './REK-CONTEXT-PLUS-MIN.json';
import REK_GEMENGD_BASIS from './REK-GEMENGD-BASIS.json';
import REK_CIJF_KEER from './REK-CIJF-KEER.json';
import REK_CIJF_DEEL from './REK-CIJF-DEEL.json';
import REK_HANDIG_DEEL from './REK-HANDIG-DEEL.json';
import REK_CONTEXT_KEER_DEEL from './REK-CONTEXT-KEER-DEEL.json';
import REK_CONTEXT_MEERSTAPS from './REK-CONTEXT-MEERSTAPS.json';
import REK_GEMENGD_TOETS from './REK-GEMENGD-TOETS.json';
const REK_FAMILY_SEEDS = [{
  file: 'src/content/seeds/REK/REK-SCHATTEN.json',
  data: REK_SCHATTEN
}, {
  file: 'src/content/seeds/REK/REK-VOLGORDE.json',
  data: REK_VOLGORDE
}, {
  file: 'src/content/seeds/REK/REK-TAFELS-BASIS.json',
  data: REK_TAFELS_BASIS
}, {
  file: 'src/content/seeds/REK/REK-CIJF-PLUS.json',
  data: REK_CIJF_PLUS
}, {
  file: 'src/content/seeds/REK/REK-CIJF-MIN.json',
  data: REK_CIJF_MIN
}, {
  file: 'src/content/seeds/REK/REK-HANDIG-PLUS-MIN.json',
  data: REK_HANDIG_PLUS_MIN
}, {
  file: 'src/content/seeds/REK/REK-TAFELS-TOEPASSEN.json',
  data: REK_TAFELS_TOEPASSEN
}, {
  file: 'src/content/seeds/REK/REK-TAFELS-UITBREIDEN.json',
  data: REK_TAFELS_UITBREIDEN
}, {
  file: 'src/content/seeds/REK/REK-HANDIG-KEER.json',
  data: REK_HANDIG_KEER
}, {
  file: 'src/content/seeds/REK/REK-CONTEXT-PLUS-MIN.json',
  data: REK_CONTEXT_PLUS_MIN
}, {
  file: 'src/content/seeds/REK/REK-GEMENGD-BASIS.json',
  data: REK_GEMENGD_BASIS
}, {
  file: 'src/content/seeds/REK/REK-CIJF-KEER.json',
  data: REK_CIJF_KEER
}, {
  file: 'src/content/seeds/REK/REK-CIJF-DEEL.json',
  data: REK_CIJF_DEEL
}, {
  file: 'src/content/seeds/REK/REK-HANDIG-DEEL.json',
  data: REK_HANDIG_DEEL
}, {
  file: 'src/content/seeds/REK/REK-CONTEXT-KEER-DEEL.json',
  data: REK_CONTEXT_KEER_DEEL
}, {
  file: 'src/content/seeds/REK/REK-CONTEXT-MEERSTAPS.json',
  data: REK_CONTEXT_MEERSTAPS
}, {
  file: 'src/content/seeds/REK/REK-GEMENGD-TOETS.json',
  data: REK_GEMENGD_TOETS
}] as const;
const allQuestions = REK_FAMILY_SEEDS.flatMap(({
  file,
  data
}) => data.questions.map(question => ({
  ...question,
  __sourceFile: file
})));
export default {
  module: 'Basisrekenen',
  moduleCode: 'REK',
  version: '4.0-fase4',
  taxonomyVersion: '4.1',
  questions: allQuestions
};